import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Mail, Phone } from "lucide-react";
import { LOGO_URL } from "@/lib/api";

const FACEBOOK = "https://www.facebook.com/share/1EwQGgCgPR/";
const INSTAGRAM = "https://www.instagram.com/stcharlesunitedfb?igsh=ZDMyMjVrMWpjemd6";
const EMAIL = "StCharlesUnited26@gmail.com";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-scu-obsidian text-white/80 mt-24">
      <div className="stripe-divider" />
      <div className="mx-auto max-w-[1400px] px-4 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} className="h-14 w-auto" alt="SCU Utes" />
            <div>
              <div className="font-bebas text-3xl tracking-wider text-white">ST. CHARLES UNITED</div>
              <div className="text-xs uppercase tracking-[0.3em] text-scu-electric">U.T.E.S.</div>
              <div className="text-xs uppercase tracking-[0.25em] text-white/60 mt-1">United Together. Empowering St. Charles.</div>
            </div>
          </div>
          <p className="mt-6 max-w-md text-sm leading-relaxed text-white/70">
            A competitive youth sports organization created to represent athletes and families throughout St. Charles Parish.
          </p>
          <p className="mt-3 text-xs uppercase tracking-[0.3em] text-scu-electric font-bold">
            Est. 2026 · Inaugural Season 2027
          </p>
        </div>
        <div>
          <h4 className="font-bebas text-xl tracking-widest text-white">Programs</h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link className="hover:text-white transition-colors" to="/football">Football</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/cheer">Cheer</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/schedule">Schedule</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/sponsors">Sponsors</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/news">News</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-bebas text-xl tracking-widest text-white">Connect</h4>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <Mail className="h-4 w-4 text-scu-electric mt-0.5 flex-shrink-0" />
              <a data-testid="footer-email" href={`mailto:${EMAIL}`} className="hover:text-white break-all">{EMAIL}</a>
            </li>
            <li className="flex items-start gap-2">
              <Phone className="h-4 w-4 text-scu-electric mt-0.5 flex-shrink-0" />
              <div className="flex flex-col gap-1">
                <div>
                  <a data-testid="footer-phone-1" href="tel:+19852103113" className="hover:text-white font-bold">(985) 210-3113</a>
                  <div className="text-[10px] uppercase tracking-widest text-white/50">Reginald Johnson</div>
                </div>
                <div>
                  <a data-testid="footer-phone-2" href="tel:+13465819282" className="hover:text-white font-bold">(346) 581-9282</a>
                  <div className="text-[10px] uppercase tracking-widest text-white/50">Shelby Boyle</div>
                </div>
              </div>
            </li>
            <li className="flex items-center gap-4 pt-2">
              <a data-testid="footer-facebook" href={FACEBOOK} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-white/70 hover:text-white transition-colors"><Facebook className="h-5 w-5" /></a>
              <a data-testid="footer-instagram" href={INSTAGRAM} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-white/70 hover:text-white transition-colors"><Instagram className="h-5 w-5" /></a>
            </li>
            <li className="pt-1"><Link className="hover:text-white transition-colors" to="/contact">Contact SCU</Link></li>
            <li><Link className="hover:text-white transition-colors" to="/faq">FAQ</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1400px] px-4 lg:px-8 py-5 flex flex-col md:flex-row justify-between text-xs text-white/50 gap-1">
          <div>© {new Date().getFullYear()} St. Charles United. All rights reserved.</div>
          <div className="tracking-widest uppercase">United Together. Empowering St. Charles.</div>
        </div>
      </div>
    </footer>
  );
}
